
import React from "react";
import EscapeButton from "../EscapeButton";

const CtaSection: React.FC = () => {
  return (
    <section className="section-container text-center" id="cta">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold mb-8">
          Você pode continuar no piloto automático — ou pode escapar agora.
        </h2>
        <p className="text-xl opacity-80 mb-8 max-w-3xl mx-auto">
          Pode seguir a rotina, as trends, os conselhos de quem nunca construiu nada.
        </p>
        <p className="text-xl font-bold mb-16 max-w-3xl mx-auto">
          Ou pode entrar agora. Matar o velho eu. E começar a ser impossível de ignorar.
        </p>
        <EscapeButton size="large">🔥 ESCAPAR AGORA</EscapeButton>
      </div>
    </section>
  );
};

export default CtaSection;
